import { render, staticRenderFns } from "./thematicTable.vue?vue&type=template&id=1c57b0ca&"
import script from "./thematicTable.vue?vue&type=script&lang=js&"
export * from "./thematicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports